/* eslint-disable no-param-reassign */
export default class Forces {
  /**
   * 
   * @param {number} m 
   * @param {number} g 
   * @param {Phaser.Math.Vector2} vector 
   */
  static constantGravity(m,g, vector) {
    vector.x = 0;
    vector.y = m * g;
  }

  /**
   * 
   * @param {number} k 
   * @param {Phaser.Math.Vector2} vel 
   * @param {Phaser.Math.Vector2} vector 
   */
  static linearDrag (k, vel, vector) {
    const velMag = vel.length();
    if (velMag > 0) {
      vector.multiply({ x: -k, y: -k });
    }
    else {
      vector.reset();
    }
  }

  /**
   * 
   * @param {Phaser.Math.Vector2[]} arr 
   * @param {Phaser.Math.Vector2} vector 
   */
  static add (arr, vector) {
    vector.reset();
    for (let i = 0; i < arr.length; i++) {
      const force = arr[i];
      vector.add(force);
    }
  }
}